<template>
  <div class="activity">
    <img class="banner-img" :src="fuwuzixun_bg" alt="" />
    <div class="title">赛事活动</div>
    <div class="activity-name">{{name}}</div>
    <div class="title">组委会</div>
    <div class="act-attention">
      <div class="act-intro">
        <!-- <div class="overallCenter attention-title">全国中小学生绘画书法作品比赛组委会</div> -->
        <div class="intro-txt" v-html="organizingCommittee"></div>
      </div>
    </div>
    <div class="title">各赛区组委会联系方式请在下拉框中查询</div>
    <div class="search" :class="{'search-Select':province.name}" @click="provincesShow = true">
      {{province.name||'请选择您所在的省份或地区'}}
      <img :src="learn_little_up_icon">
    </div>
    <van-popup v-model="provincesShow" position="bottom">
      <van-picker
        value-key='areaName'
        show-toolbar
        :columns="provincesArr"
        @confirm="provincesAdd"
        @cancel="provincesShow = false"
      />
    </van-popup>
    <div class="Company-card" v-for="(time,index) in companyArr" :key="index">
      <div class="overallCenter card-label">{{time.contactProvince}}</div>
      <div class="overallLeft card-title">
        <img :src="time.userImg">
        <div>{{time.name}}</div>
      </div>
      <div class="overallbaseline info">
        <div class="info-key">所在地址：</div>
        <div class="info-value">{{time.contactProvince+time.contactCity+time.contactArea+time.contactAdress}}</div>
      </div>
      <div class="overallbaseline info">
        <div class="info-key">联 系 人：</div>
        <div class="info-value">{{time.delegateName}}</div>
      </div>
      <div class="overallbaseline info">
        <div class="info-key">联系电话：</div>
        <div class="info-value">{{time.delegateTel}}</div>
      </div>
      <!-- <div class="overallbaseline info">
        <div class="info-key">联系邮箱：</div>
        <div class="info-value">{{time.delegateEmail}}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  getChannels,
  getAllProvinces
} from "@/utils/api/home";
export default {
  data() {
    return {
      fuwuzixun_bg:require("@/assets/images/active/fuwuzixun_bg.png"),
      learn_little_up_icon:require("@/assets/images/active/learn_little_up_icon.png"),
      organizingCommittee:'',
      // 活动id
      activityId:'',
      // 角色
      role: 0,
      // 活动简介
      intro: ``,
      // 单位显示
      unitShow: false,
      // 活动名称
      name: "",
      // 互动海报
      poster: null,
      // 活动状态
      type: 0,
      province:{
        name:'',
      },
      provincesShow:false,
      provincesArr:[],
      companyArr:[],
    };
  },
  mounted() {
    this.role = this.$store.state.role;
    const infos = JSON.parse(window.localStorage.getItem("active_infos_data"));
    this.activityId = infos.id;
    this.intro = infos.synopsis;
    this.organizingCommittee = infos.organizingCommittee;
    this.name = infos.name;
    this.poster = infos.posterUrl;
    this.type = infos.typeId;
    this.AllProvinces()
  },
  methods: {
    /**
     * @description: 获取省数据
     * @author: wangxiaoheng
     */
    AllProvinces(){
      getAllProvinces(this.activityId).then((res) => {
        if (res.success) {
          this.provincesArr = res.data
        }
      })
    },
    /**
     * @description: 赛区选择
     * @param {*} data  选中数据
     * @author: wangxiaoheng
     */
    provincesAdd(data){
      this.province.name = data.areaName;
      this.province.zoneId = data.id;
      this.provincesShow = false;
      getChannels(this.activityId,data.id).then((res) => {
        if (res.success) {
          this.companyArr = res.data
        }else{
          this.$root.$toast.fail(res.message);
        }
      })
    },

  },
};
</script>

<style lang="scss" scoped>
.activity {
  padding-bottom: 1px;
  min-height: 100vh;
  background: #F7F7FA;
  .banner-img {
    width: 375px;
    height: 120px;
  }
  .title{
    margin-top: 22px;
    margin-left: 15px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #404046;
    text-align: left;
  }
  .activity-name{
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 16px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8E8E94;
    text-align: left;
  }
  .act-attention {
    width: 345px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 10px auto;
    .attention-title{
      width: 345px;
      height: 32px;
      background: rgba(86, 159, 255, 0.1);
      border-radius: 6px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #569FFF;
    }
    .intro-txt{
      padding: 0 10px;
    }
    .act-intro {
      padding: 10px 0;
      line-height: 22px;
      font-size: 14px;
      color: #999;
    }
  }
  .search{
    position: relative;
    width: 345px;
    height: 40px;
    margin: 10px auto;
    padding: 10px;
    background: #FFFFFF;
    border: 1px solid #83E38F;
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #C7C7CD;
    text-align: left;
    img{
      position: absolute;
      right: 10px;
      width: 20px;
      height: 20px;
    }
  }
  .search-Select{
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #404046;
  }
  .Company-card{
    position: relative;
    width: 345px;
    min-height: 221px;
    background: #FFFFFF;
    border-radius: 6px;
    margin:0 auto;
    margin-bottom: 10px;
    padding: 16px;
    .card-label{
      position: absolute;
      top: 0px;
      left: 0px;
      min-width: 54px;
      height: 20px;
      background: #83E38F;
      border-radius: 6px 0px 6px 0px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
    .card-title{
      width: 315px;
      height: 74px;
      border-bottom: 1px solid #EEF1F5;
      img{
        width: 40px;
        min-width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      img[src=''],
      img:not([src]) {
        opacity: 0;
      }
      div{
        margin-left: 8px;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #404046;
        overflow: hidden;      
        text-overflow: ellipsis;      
        display: -webkit-box; 
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; 
      }
    }
    .info{
      margin-top: 10px;
      .info-key{
        width: 70px;
        min-width: 80px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #8E8E94;
        text-align: left;
      }
      .info-value{
        width: 250px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #404046;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">

</style>
